import { useSelector } from 'react-redux';
import { ImageList, ImageListItem } from '@mui/material';

import { selectImages } from 'main/store/memory/selectors';
import { BasePage } from 'main/components/_common/BasePage';

export const MemoryPage = () => {
    const images = useSelector(selectImages);

    return (
        <BasePage title="思い出写真">
            <ImageList variant="masonry" cols={2} gap={8} sx={{ width: '100%', height: '100hv', px: 1 }}>
                {images.map(image => (
                    <ImageListItem key={image.fileName}>
                        <img
                            src={`https://firebasestorage.googleapis.com/v0/b/sagami-bombers.appspot.com/o/${image.fileName}?alt=media&token=${image.token}`}
                            alt=""
                        />
                    </ImageListItem>
                ))}
            </ImageList>
        </BasePage>
    )
}
